<template>
  <div class="account-body" style="display:flex;flex-direction:column;padding:24px 24px 70px 24px;height:100%">
    <a-row style="height:482px">
      <a-col :span="24">
        <div class="account-info">
          <div class="account-info-text">
            个人资料
          </div>
          <a-divider style="color:rgba(240, 240, 240, 1);margin:0px" />
          <div style="margin-top:24px;padding-left:24px">
            <div style="display:flex">
              <span style="display:inline-block;width:116px;color:rgba(51, 51, 51, 1);font-size:16px;float:left">账号信息</span>
              <span style="flex:1;padding-right:24px;">
                <div style='border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:24px;height:124px;'>
                  <a-avatar style="width:100px;height:100px;float:left;cursor:pointer" :src="currentAvatarUl" @click="showModal('avatar')"/>
                  <div style="display:inline-block;margin-left:24px;margin-top:24px">
                      <div style="color:rgba(51, 51, 51, 1);font-size:18px">账号ID：{{enterprise.id}}</div>
                      <div style="color:rgba(204, 204, 204, 1);font-size:12px">
                        <span style="display:inline-block;">注册时间：</span>
                        <span>{{enterprise.createTime}}</span>
                      </div>
                  </div>
                </div>
              </span>
            </div>
            <div style="clear:both"></div>
            <div style="display:flex;margin-top:24px;">
              <div style="color:rgba(51, 51, 51, 1);font-size:16px;width:116px;">个人信息</div>
              <div style="flex:1">
                <div>
                  <span>企业名称：</span>
                    <a-input style="width:510px;" v-model="enterpriseName" />
                </div>
                <div style="margin:24px 0;">
                  <span style="float:left">企业简介：</span>
                  <a-textarea style="width:510px;" rows="2" v-model="enterpriseIntroduction" />
                </div>
                <div>
                  <span>项目权限：</span>
                    <a-select
                      style="width:510px;"
                      v-model="couponSelected"
                    >
                      <a-select-option value="CAN_DOWNLOAD" title='提供下载权限'>提供下载权限</a-select-option>
                      <a-select-option value="ONLY_VIEW" title='仅提供查看'>仅提供查看</a-select-option>
                      <a-select-option value="NOT_OPEN" title='仅自己可见'>仅自己可见</a-select-option>
                    </a-select>
                </div>
                <div style="margin-top:24px">
                  <a-button style="margin-left:518px;background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1)" @click="handleSubmit" type="primary">提交</a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <div class="relate-app">
      <div class="title">
        <span>账号设置</span>
        <!-- <a-button @click="goToMiddleCenter" type="primary">进入中台</a-button> -->
      </div>
      <a-divider style="color:rgba(240, 240, 240, 1);margin:0px"  />
      <div class="personal-info" style="">
        <div style="padding:24px;display:flex;">
          <div style="display:inline-block;width:116px;">基本设置</div>
          <div style="flex:1;font-size:14px;color:rgba(128, 128, 128, 1)">
            <!-- <div style="display:flex;">
              <span style="display:inline-block;width:90px">微信号：</span>
              <span style="display:inline-block;width:100px">{{enterprise.wxNickname==""?"未绑定":enterprise.wxNickname}}</span>
              <span style="display:inline-block;width:90px;color:rgba(34, 215, 187, 1)" class="pointer" @click="showModal('wxNickname')">更改</span>
            </div> -->
            <div>
              <span style="display:inline-block;width:90px">手机号：</span>
              <span style="display:inline-block;width:100px">{{enterprise.phone}}</span>
              <span style="display:inline-block;width:90px;color:rgba(34, 215, 187, 1)" class="pointer" @click="showModal('phone')">更改</span>
            </div>
            <div style="margin-top:24px">
              <span style="display:inline-block;width:90px">登陆密码：</span>
              <span style="display:inline-block;width:100px">******</span>
              <span style="display:inline-block;width:90px;color:rgba(34, 215, 187, 1)" class="pointer" @click="showModal('password')">更改</span>
            </div>
          </div>
        </div>
        <div style="margin-top:28px;padding-left:24px;">
          <!-- <div @click="loginFast" style="display:inline-block;width:240px;height:100px;border:1px solid rgba(238, 238, 238, 1);padding:22px 25px;border-radius:4px;cursor:pointer">
            <img style="width:58px;" src="../../assets/img/eocc.jpg" alt="">
            <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;margin-left:24px;">EOCC</span>
          </div> -->
          <!-- <div @click="loginMsg" style="display:inline-block;width:240px;height:100px;border:1px solid rgba(238, 238, 238, 1);padding:22px 25px;border-radius:4px;cursor:pointer;">
            <img style="width:58px;" src="../../assets/img/message.png" alt="">
            <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;margin-left:24px;">短信服务</span>
          </div> -->
        </div>
      </div>
    </div>

    <a-modal
      :mask-closable="true"
      :title="modalTitle"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="确认" cancelText="取消"
    >
      <div v-if="showModalNum==1" class="show-avatar">
        <span v-for="(item, index) in avaterList" :key="index" style="margin-bottom:8px;margin-right:8px">
          <img @click="chooseAvatar(item,index)" :class="{'active':selectAvatar==index}" :src='item' alt="">
        </span>
      </div>
      <div v-if="showModalNum==2" class="show-avatar">
        <a-input style="width:300px" placeholder="请输入新手机号码" v-model="phoneNum" />
        <a-button style="margin-left:20px" type="primary" @click="getVerificationCode()">获取验证码</a-button>
        <a-input style="width:150px;margin-top:20px" v-model="verificationCode" placeholder="请输入验证码" />
      </div>
      <div v-if="showModalNum==3" class="show-avatar">
        <a-input placeholder="请输入新微信号" />
      </div>
      <div v-if="showModalNum==4" class="show-avatar">
        <a-input v-model="inputPassword" type="password" placeholder="请输入新密码" />
        <a-input v-model="checkPassword" type="password" placeholder="请再次确认密码" style="margin-top:20px" />
      </div>
    </a-modal>
    <a-modal
      :mask-closable="true"
      title="主题设置"
      :visible="themeVisible"
      @cancel="offChangeTheme"
      width='772px'
      :footer="null"
    >
      <div>
        <div style="color:rgba(51, 51, 51, 1);font-size:18px;">请选择主题</div>
        <div class="theme-list">
          <div  @click="changeTheme('#992777',index)" v-for="(item, index) in colorList" :key="index" :class="{'active':currentIndex==index}" style="display:inline-block;width:225px;margin-top:24px;">
            <img style="width:100%;height:100%" src="../../assets/img/pro1.png" alt="">
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'accountInfo',
  props: {
    msg: String
  },
  data () {
    return {
      description: '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',
      form: this.$form.createForm(this),
      visible: false,
      showModalNum: 0,
      avaterList: [],
      selectAvatar: -1,
      currentAvatarUl: '',
      enterprise:{},
      testData: "测试数据",
      verificationCode: '',
      phoneNum: '',
      inputPassword: '',
      checkPassword: '',
      couponSelected: 'ONLY_VIEW',
      enterpriseName: "",
      enterpriseIntroduction: "",
      modalTitle: '',
      themeVisible: false,
      currentIndex: 0,
      colorList: [
        'rgba(34, 215, 187, 1)', 
        'rgba(78, 138, 250, 1)',
        'rgba(255, 141, 26, 1)',
        'rgba(255, 196, 66, 1)',
        'rgba(250, 90, 85, 1)',
        'rgba(250, 90, 85, 1)',
        'rgba(202, 67, 226, 1)',
      ]
    }
  },
  mounted(){
    this.sessionData('set','leftNavItem','accountInfo');
    this.axios.get('/api/enterprise')
      .then(response=> {
        if(response.data.code == 0){
          this.enterprise = response.data.data
          this.couponSelected = response.data.data.projectAuth
          this.enterpriseName = response.data.data.name
          this.enterpriseIntroduction = response.data.data.introduction
          this.currentAvatarUl = response.data.data.avatar
        }else{
          this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error);
      })
  },
  methods: {
    loginFast() {
      this.axios({
        method:'get',
        url:'/api/enterprise/advanceToken', 
      })
      .then(response=> {
        if(response.data.code==0){
            let token = response.data.data.token
            window.open('http://eocc.sipgo.cn/#/LoginAuto?token='+token);
        }else{
            this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    loginMsg() {
      this.axios({
        method:'get',
        url:'/api/enterprise/advanceToken', 
      })
      .then(response=> {
        if(response.data.code==0){
            let token = response.data.data.token
            window.open('http://sms.sipgo.cn/#/LoginAuto?token='+token);
        }else{
            this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    handleSubmit () {
      this.sessionData('set','avatar',this.currentAvatarUl);
      this.axios.post('/api/enterprise/base', {
        avatar: this.currentAvatarUl,
        name: this.enterpriseName,
        introduction: this.enterpriseIntroduction,
        projectAuth: this.couponSelected
      })
      .then(response=> {
        if(response.data.code == 0){
          this.resetSetItem('avatar',this.currentAvatarUl);
          this.resetSetItem('userName',this.enterpriseName);
          this.$message.success('信息修改成功');
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })

    },
    showModal(type) {
      this.visible = true;
      if(type == 'avatar'){
        this.modalTitle = '更换头像'
        this.showModalNum = 1
        this.axios.get('/api/sys/avatar/list')
          .then(response=> {
            if(response.data.code == 0){
              this.avaterList = response.data.data
            }else{
              this.$message.error(response.data.message);
            }
          })
          .catch(error=> {
            console.log(error);
          })
      }else if(type == "phone"){
        this.modalTitle = '更换手机号'
        this.showModalNum = 2
      }else if(type == "wxNickname"){
        this.modalTitle = '修改微信号'
        this.showModalNum = 3
      }else if(type == "password"){
        this.modalTitle = '修改密码'
        this.showModalNum = 4
      }
    },
    handleOk() {
      if(this.showModalNum == 1){
        this.visible = false;
        this.handleSubmit()
      }else if(this.showModalNum == 2){
        this.axios.post('/api/enterprise/phone', {
          phone: this.phoneNum,
          verifyCode: this.verificationCode
        })
        .then(response=> {
          if(response.data.code == 0){
            this.visible = false;
            this.$message.success('修改成功');
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error);
        });
      }else if(this.showModalNum == 3){
        this.visible = false;
      }else if(this.showModalNum == 4){
        if(this.inputPassword == this.checkPassword){
          this.axios.post('/api/enterprise/password', {
            password: this.inputPassword,
          })
          .then(response=> {
            if(response.data.code == 0){
              this.visible = false;
              this.$message.success('修改成功');
            }else{
              this.$message.error(response.data.message);
            }
          })
          .catch(error=> {
            console.log(error);
          });
        }else{
          this.$message.error('两次密码输入不一致');
        }
      }
    },
    handleCancel() {
      this.visible = false;
    },
    offChangeTheme() {
      this.themeVisible = false
      this.currentIndex = 0
    },
    chooseAvatar(value,key) {
      if(key == this.selectAvatar){
        this.selectAvatar = -1
        this.currentAvatarUl = this.sessionData('get','avatar')
      }else{
        this.selectAvatar = key
        this.currentAvatarUl = value
      }
    },
    getVerificationCode() {
      this.axios.post('/api/verifyCode', {
        phone: this.phoneNum,
        type: '1'
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('短信发送成功');
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },

    goToMiddleCenter() {
      let host = window.location.host
      this.axios(
          {
              method:'get',
              url:'/api/intelligence/superLoginUrl', 
              params: {
                  hostName: host
              }
          }
      )
      .then(response=> {
          if(response.data.code == 0){
              let url = response.data.data.superLoginUrl
              window.location.href = url 
          }else{
              this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .account-body{
    // height: 100%;
    .account-info{
      width: 100%;
      background: #fff;
      height: 482px;
    }
    .account-info-text{
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      font-weight: bold;
      padding-left:24px;
      // padding-top: 24px;
      height: 59px;
      line-height: 59px;
    }
    .personal-info{
      width: 100%;
      background: #fff;
      // height: 482px;
    }
    .theme{
      width: 100%;
      background: #fff;
      padding: 24px;
      margin-top:19px;
      .theme-title{
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
      }
    }
    .personal-info-text{
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      font-weight: bold;
      padding-left:24px;
      // padding-top: 24px;
      height: 59px;
      line-height: 59px;
    }
    .personal-info div.ant-row-flex{
      margin-top: 7px;
    }
    .pointer{
      cursor: pointer;
    }
    .relate-app{
      background: #fff;
      margin-top: 16px;
      padding-bottom: 24px;
      flex: 1;
      .title{
        padding: 0 24px;
        height: 59px;
        line-height: 59px;
        span{
          font-size: 18px;
          color: rgba(51, 51, 51, 1);
          font-weight: bold;
        }
        button{
          float: right;
          background: rgba(34, 215, 187, 1);
          border-color: rgba(34, 215, 187, 1);
          margin-top: 14px;
        }
      }
    }
  }
  .show-avatar{
    span{
      display: inline-block;
      width: 100px;
      height: 100px;
    }
    img{
      width:100px;
      height:100px;
      margin-right:10px;
      margin-bottom:10px;
      cursor: pointer;
    }
    img.active{
      box-shadow: 0px 0px 2px 2px #1890ff;
    }
  }
  .theme-list{
    div{
      margin-right: 24px;
      padding:5px;
      cursor: pointer;
    }
    div:nth-child(3){
      margin-right: 0px;
    }
    div:nth-child(6){
      margin-right: 0px;
    }
    div.active{
      border: 1px solid #22d7bb;
    }
  }

  
</style>
